import React, { useState } from "react";
import ButtonComponent from "../../../components/common/button/Button";
import './ViewAllDetails.css';
import Modal from "../../../components/common/modal/Modal";
import TextField from '@mui/material/TextField';
import Chip from "@mui/material/Chip";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Loader } from "../../../components/common/Loader";

const LeadtimeModel = ({ openViewAllModal, data, handleCloseViewAllModal, loading }) => {

  return (
    <div>
      <Modal
        className="LeadTimeModal_cls"
        open={openViewAllModal}
        handleClose={handleCloseViewAllModal}
        title="Input Data for Lead Time Analytics"
        action={
          <LeadeTimeFooter
            className="viewAllDetails_cls"
            handleCloseModal={handleCloseViewAllModal}
          />
        }
        content={
          <LeadeTimeContent data={data} loading={loading} />
        }
      />
    </div>
  )
}
export default LeadtimeModel;

const LeadeTimeFooter = ({ handleCloseModal }) => {
  return (
    <div className='button-alignment'>
      <ButtonComponent
        maxWidth="170px"
        label="Close"
        type="secondary"
        onClick={handleCloseModal}
      />
    </div>
  )
}
const LeadeTimeContent = ({ data, loading }) => {

  const [openBoxModal, setOpenBoxModal] = useState(false);
  const [selectedBoxDetails, setSelectedBoxDetails] = useState({});

  const renderTextAreaValue = (ranges) => {
    return ranges?.map((item, index) => `<Range${index + 1} from "${item.excludeFrom}" to "${item.excludeTo}">`)
      .join(" ");
  };


  const renderTextField = (value) => {
    return <TextField
      id="outlined-read-only-input"
      sx={{
        "& .MuiOutlinedInput-root": {
          height: 40,
          width: 200
        }

      }}
      freeSolo
      defaultValue={value}
      value={value}
      slotProps={{
        input: {
          readOnly: true,
        },
      }}
    />
  }
  const handleClickInside = (mappedData, name) => {
    setOpenBoxModal(true);
    setSelectedBoxDetails({ mappedData: mappedData, name: name })
  };
  const handleCloseBoxModel = () => {
    setOpenBoxModal(false);
    setSelectedBoxDetails({ mappedData: {}, name: "" })
  };
  const renderBoxItems = (mappedData, name) => {
    const isDisabled = !mappedData || mappedData?.length === 0;
    return <div>
      <Box
        onClick={!isDisabled ? () => handleClickInside(mappedData, name) : undefined}
        style={{
          height: "50px",
          width: "180px",
          display: 'flex',
          overflowY: "auto",
          flexWrap: "wrap",
          gap: "4px",
          padding: "8px",
          border: "1px solid #ccc",
          borderRadius: "4px",
          transition: "all 0.3s ease",
          cursor: isDisabled ? "default" : "pointer",
          backgroundColor: isDisabled ? "#f0f0f0" : "white",
          opacity: isDisabled ? 0.6 : 1,
        }}
      >
        {mappedData?.map((option, index) => (
          <Chip
            label={option}
            key={index}
          />
        ))}
      </Box>
    </div>
  }

  return (
    loading ?
      <div className="viewDetailsContent_cls"><Loader className="viewDetailsContent_cls" /></div> :
      <div>
        <div className="viewDetailsContent_cls">
          <div className="row-1">
            <div>
              <p>Plant</p>
              {renderTextField(data?.plant)}
            </div>
            <div>
              <p>Purchasing Group</p>
              {renderBoxItems(data?.purchasingGroups, "Purchasing Group")}
            </div>
            <div>
              <p>MRP Controller</p>
              {renderBoxItems(data?.mrpControllers, "MRP Controller")}
            </div>
          </div>
          <div className="row-1">
            <div>
              <p>S-Code (Ext Material Group)</p>
              {renderBoxItems(data?.scodes, "S-Code (Ext Material Group)")}
            </div>
            <div>
              <p>Incoterms Location</p>
              {renderBoxItems(data?.incotermsLocations, "Incoterms Location")}
            </div>
            <div>
              <p>Supplier Code</p>
              {renderBoxItems(data?.supplierIds, "Supplier Code")}
            </div>

          </div>
          <div className="row-1">
            <div>
              <p>Supplier Name</p>
              {renderBoxItems(data?.supplierNames, "Supplier Name")}
            </div>
            <div>
              <p>Material Group</p>
              {renderBoxItems(data?.materialGroups, "Material Group")}
            </div>
            <div>
              <p>Material Type</p>
              {renderBoxItems(data?.materialTypes, "Material Type")}
            </div>

          </div>
          <div className="row-1">
            <div>
              <p>Material</p>
              {renderBoxItems(data?.materialIds, "Material")}
            </div>
            <div>
              <p>Mode of Transport</p>
              {renderBoxItems(data?.modeOfTransports, "Mode of Transport")}
            </div>
            <div>
              <p>Period From</p>
              {renderTextField(data?.periodFrom)}
            </div>

          </div>
          <div className="row-1">
            <div>
              <p>Period To</p>
              {renderTextField(data?.periodTo)}
            </div>
            <div>
              <p>Exclude Range in the Period Selected</p>
              <div>
                <TextField
                  freeSolo
                  multiline
                  rows={4}
                  value={renderTextAreaValue(data?.excludeRanges)}
                  slotProps={{
                    input: {
                      readOnly: true,
                    },
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      width: 300
                    }
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <Dialog open={openBoxModal} onClose={handleCloseBoxModel} className="dialogBoxModal_viewAll" key={selectedBoxDetails?.name}>
          <DialogTitle>{`${selectedBoxDetails?.name} (${selectedBoxDetails?.mappedData?.length})`}</DialogTitle>
          <DialogContent sx={{ maxHeight: "300px", overflowY: "auto" }}>
            {selectedBoxDetails?.mappedData?.length > 0 ? (
              selectedBoxDetails?.mappedData?.map((option, index) => (
                <Chip
                  key={index}
                  label={option}
                  sx={{ margin: "4px" }}
                />
              ))
            ) : (
              <p>No items selected</p>
            )}
          </DialogContent>
          <DialogActions>
            <ButtonComponent onClick={handleCloseBoxModel} type="primary" label="Close" />
          </DialogActions>
        </Dialog>
      </div>
  )
}